import React from 'react';
import SpinnerLoader from '../../../components/SpinnerLoader/SpinnerLoader';

export interface DataLoadingWrapperProps {
  isLoading: boolean;
  dataExists: boolean;
  children: React.ReactNode
}

export const DataLoadingWrapper = ({isLoading, dataExists, children}: DataLoadingWrapperProps) => {

  if (!dataExists && isLoading) {
    return (
      <div className="flex flex-row items-center justify-center">
        <SpinnerLoader />
      </div>
    );
  }

  if (!dataExists && !isLoading) {
    return null;
  }

  return children
};
